import { render } from "./createSponsorAccount.vue?vue&type=template&id=1e6eeaf4"
import script from "./createSponsorAccount.vue?vue&type=script&lang=js"
export * from "./createSponsorAccount.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__